import { Radio } from "antd";
import { useIntl } from "react-intl";

const RadioGiftCard = ({ data }: any) => {
  const intl = useIntl();
  console.log(data);

  return (
    <div className="custom-radio-group">
      <Radio
        value={data}
        className="rounded-lg border-solid border-[#4F5062] border-[1px] px-4 py-3 font-semibold mx-2 text-xs"
      >
        <span className="text-base font-semibold">{data.value}</span>
        <span className="text-[#75757E] text-[11px] !mt-4 !mx-1">
          {intl.formatMessage({ id: "saudi_riyal" })}
        </span>
      </Radio>
    </div>
  );
};

export default RadioGiftCard;
